import { render, staticRenderFns } from "./av-back-hair.vue?vue&type=template&id=11b139ad&"
import script from "./av-back-hair.vue?vue&type=script&lang=js&"
export * from "./av-back-hair.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports